import React from 'react';
import { createContext } from 'react';
export var PrefetchContext = createContext(undefined);
export var PrefetchProvider = function (_a) {
    var children = _a.children, prefetchPromise = _a.prefetchPromise;
    return React.createElement(PrefetchContext.Provider, { value: prefetchPromise }, children);
};
//# sourceMappingURL=prefetch-context.js.map